/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  OrgJoinRequestItem,
  PendingJoinRequestResponse,
  ProcessJoinRequestsModel,
  ProcessJoinRequestsResult,
} from '../models/index';
import {
    OrgJoinRequestItemFromJSON,
    OrgJoinRequestItemToJSON,
    PendingJoinRequestResponseFromJSON,
    PendingJoinRequestResponseToJSON,
    ProcessJoinRequestsModelFromJSON,
    ProcessJoinRequestsModelToJSON,
    ProcessJoinRequestsResultFromJSON,
    ProcessJoinRequestsResultToJSON,
} from '../models/index';

export interface ApiOrgJoinRequestsProcessJoinRequestsPutRequest {
    processJoinRequestsModel?: ProcessJoinRequestsModel;
}

/**
 * 
 */
export class OrgJoinRequestsApi extends runtime.BaseAPI {

    /**
     */
    async apiOrgJoinRequestsCancelMyJoinRequestDeleteRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/OrgJoinRequests/CancelMyJoinRequest`;

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiOrgJoinRequestsCancelMyJoinRequestDelete(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiOrgJoinRequestsCancelMyJoinRequestDeleteRaw(initOverrides);
    }

    /**
     */
    async apiOrgJoinRequestsGetAllJoinRequestsGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OrgJoinRequestItem>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/OrgJoinRequests/GetAllJoinRequests`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OrgJoinRequestItemFromJSON));
    }

    /**
     */
    async apiOrgJoinRequestsGetAllJoinRequestsGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OrgJoinRequestItem>> {
        const response = await this.apiOrgJoinRequestsGetAllJoinRequestsGetRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async apiOrgJoinRequestsGetMyPendingJoinRequestGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PendingJoinRequestResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/OrgJoinRequests/GetMyPendingJoinRequest`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PendingJoinRequestResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiOrgJoinRequestsGetMyPendingJoinRequestGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PendingJoinRequestResponse> {
        const response = await this.apiOrgJoinRequestsGetMyPendingJoinRequestGetRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async apiOrgJoinRequestsProcessJoinRequestsPutRaw(requestParameters: ApiOrgJoinRequestsProcessJoinRequestsPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProcessJoinRequestsResult>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/OrgJoinRequests/ProcessJoinRequests`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ProcessJoinRequestsModelToJSON(requestParameters['processJoinRequestsModel']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProcessJoinRequestsResultFromJSON(jsonValue));
    }

    /**
     */
    async apiOrgJoinRequestsProcessJoinRequestsPut(requestParameters: ApiOrgJoinRequestsProcessJoinRequestsPutRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProcessJoinRequestsResult> {
        const response = await this.apiOrgJoinRequestsProcessJoinRequestsPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
